import sync from "shared/invoca_sync";
import setupAjax from "shared/invoca_app/setup_ajax";

import Backdraft from "backdraft-app/src/backdraft";

Backdraft.plugin("InvocaSync", plugin => {
  plugin.initializer(app => {
    setupAjax();
    app.sync = sync;
  });
});
